import BaseApi from './BaseApi';

export interface ILeaseClauseType {
    getAll(clientNumber: number, projectId: number, jwt: string): Promise<object>;
}

export default class LeaseClauseType extends BaseApi implements ILeaseClauseType {
    constructor(baseUrl: string) {
        super(baseUrl);
    }

    getAll = (clientNumber: number, projectId: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectId}/lease-clause-types`, jwt);
    };
}



// WEBPACK FOOTER //
// ./src/api/LeaseClauseType.ts